<template>
  <div>
    <v-data-table :headers="headers" :items="listRequirementCategory" dense @click:row="onClickRow">
      <template v-slot:top>
        <v-toolbar flat>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="success"
                v-on="on"
                dark
                rounded
                :to="{ name: 'Create Requirement Category' }"
              >
                <v-icon>
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>Create</span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <template v-slot:item.no="{ item }">
        {{ listRequirementCategory.map(x => x).indexOf(item) + 1 }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn color="primary" @click.stop="openDialog(item)">Add Department</v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>

    <dialog-form-department
      :dialog="dialog"
      :form="item"
      :departments="departments"
      @save="save"
      @close="close"
    ></dialog-form-department>
  </div>
</template>

<script>
import DialogFormDepartment from "./DialogFormDepartment.vue";

export default {
  name: "requirement-category",
  components: {
    DialogFormDepartment,
  },
  data: () => ({
    dialog: false,
    item: {},
    headers: [
      {
        text: "No",
        align: "center",
        sortable: false,
        value: "no",
        divider: true,
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Name",
        value: "name",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Account Name",
        value: "accountName",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Account Number",
        value: "accountNumber",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
      {
        text: "Action",
        value: "action",
        sortable: false,
        divider: true,
        align: "center",
        class: "light-blue lighten-2 font-weight-black",
      },
    ],
    departments: [],
    listRequirementCategory: [],
  }),

  created() {
    this.initialize();
    this.getDepartment();
  },

  methods: {
    async initialize() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("requirementCategory/getAll")
        .then(response => {
          this.listRequirementCategory = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    async getDepartment() {
      await this.$store
        .dispatch("external/getDepartment")
        .then(response => {
          this.departments = response.data;
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
        });
    },
    onClickRow(item) {
      this.$router.push({ name: "Detail Requirement Category", params: { id: item.id } });
    },
    openDialog(item) {
      this.dialog = true;
      this.item = item;
    },
    close() {
      this.dialog = false;
      this.item = {};
    },
    async save(item) {
      await this.$store
        .dispatch("requirementCategory/create", item)
        .then(() => {
          this.$store.dispatch("toast", {
            type: "success",
            message: "Data berhasil disimpan",
          });
          this.close();
          this.initialize();
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
        });
    },
  },
};
</script>

<style></style>
